import { Modal, ModalProps, useModal } from "@/shared/modal";
import { useTranslations } from "use-intl";
import "@cyntler/react-doc-viewer/dist/index.css";
import { ReactNode } from "react";
import { DocViewer } from "@/shared/form/button/document-button";
import { DocViewerFileFragment } from "gql/graphql";

type DocumentModalProps = {
  modalProps?: ModalProps;
  file: DocViewerFileFragment;
  name: string;
};

export function DocumentModal({ modalProps, file, name }: DocumentModalProps) {
  const t = useTranslations("Common");

  return (
    <Modal
      title={t("DOCUMENT_WITH_NAME", { name })}
      width={1440}
      {...modalProps}
    >
      <div className="aspect-[9/16] xl:aspect-video [&_#proxy-renderer]:grow [&_#msdoc-renderer]:!h-full">
        <DocViewer file={file} />
      </div>
    </Modal>
  );
}

type DocumentModalWrapperProps = DocumentModalProps & {
  children: (props: { open: () => void }) => ReactNode;
};

export function DocumentModalWrapper({
  children,
  ...documentModalProps
}: DocumentModalWrapperProps) {
  const { open, close, openModal } = useModal();

  return (
    <>
      {children({ open })}
      <DocumentModal
        {...documentModalProps}
        modalProps={{
          open: openModal,
          onCancel: close,
        }}
      />
    </>
  );
}
